import { Injectable } from '@angular/core';
import { UtilsManager } from 'src/app/managers/utils/utils.manager';
import { NotifierManager } from 'src/app/managers/notifier/notifier.manager';
import { Notifier } from 'src/app/enums/notifier/notifier.enum';
import { NotifierMessage } from 'src/app/enums/notifier/message/notifier.enum';
import { RequestManager } from 'src/app/managers/request/request.manager';
import { ErrorManager } from 'src/app/managers/error/error.manager';
import { Site } from 'src/app/beans/site/site.bean';
import { Slot } from 'src/app/beans/slot/slot.bean';

@Injectable
  ({
    providedIn: 'root'
  })
export class SlotHandler
{
  constructor(
    private _utils: UtilsManager,
    private _notifier: NotifierManager,
    private _request: RequestManager,
    private _error: ErrorManager
  ) { }

  async list(token: string, organizationId: number, serviceId: number, date: string) {
    if (!this._utils.checker().isValidText(token)) {
      this._notifier.show(
        Notifier.WARNING,
        NotifierMessage.INVALID_PASSWORD
      )
      return undefined
    }

    if (!this._utils.checker().isValidId(serviceId)) {
      this._notifier.show(
        Notifier.WARNING,
        NotifierMessage.INVALID_SERVICE_ID
      )
      return undefined
    }

    if (!this._utils.checker().isValidText(date)) {
      this._notifier.show(
        Notifier.WARNING,
        NotifierMessage.INVALID_SLOT_DATE
      )
      return undefined
    }

    try {
      let response
      if (organizationId == 200)  response = await this._request.slot().listAQP(token, serviceId, date).toPromise()
      else                        response = await this._request.slot().list(token, serviceId, date).toPromise()

      if (this._error.hasError(response)) {
        // MANAGE ERROR
        return this._error.handleCQWebapp(response)
      }

      return response

    } catch (error) {
      // this._error.handleNetwork ( error )
      return undefined
    }
  }

  async day(token: string, serviceId: number, date: string, type: number)
  {
    if (!this._utils.checker().isValidText(token)) {
      this._notifier.show(
        Notifier.WARNING,
        NotifierMessage.INVALID_PASSWORD
      )
      return undefined
    }

    if (!this._utils.checker().isValidId(serviceId)) {
      this._notifier.show(
        Notifier.WARNING,
        NotifierMessage.INVALID_SERVICE_ID
      )
      return undefined
    }

    if (!this._utils.checker().isValidText(date)) {
      this._notifier.show(
        Notifier.WARNING,
        NotifierMessage.INVALID_SLOT_DATE
      )
      return undefined
    }

    try {
      const response = await this._request.slot().day(token, serviceId, date, type).toPromise()

      if (this._error.hasError(response)) {
        // MANAGE ERROR
        return this._error.handleCQWebapp(response)
      }

      return response

    } catch (error) {
      // this._error.handleNetwork ( error )
      return undefined
    }
  }

  async visibility()
  {
    try
    {
      const response = await this._request.slot().visibility().toPromise()

      if (this._error.hasError(response))
      {
        // MANAGE ERROR
        return this._error.handleCQWebapp(response)
      }

      return response

    } catch (error)
    {
      // this._error.handleNetwork ( error )
      return undefined
    }
  }

  async create(token: string, serviceId: number, date: string, time: string, flag: number)
  {
    if (!this._utils.checker().isValidText(token)) {
      this._notifier.show(
        Notifier.WARNING,
        NotifierMessage.INVALID_PASSWORD
      )
      return undefined
    }

    if (!this._utils.checker().isValidId(serviceId)) {
      this._notifier.show(
        Notifier.WARNING,
        NotifierMessage.INVALID_SERVICE_ID
      )
      return undefined
    }

    if (!this._utils.checker().isValidText(date)) {
      this._notifier.show(
        Notifier.WARNING,
        NotifierMessage.INVALID_SLOT_DATE
      )
      return undefined
    }

    if (!this._utils.checker().isValidText(time)) {
      this._notifier.show(
        Notifier.WARNING,
        NotifierMessage.INVALID_SLOT_TIME
      )
      return undefined
    }

    try {
      const response = await this._request.slot().create(token, serviceId, date, time, flag).toPromise()

      if (this._error.hasError(response)) {
        // MANAGE ERROR
        return this._error.handleCQWebapp(response)
      }
      else {
        this._notifier.show(
          Notifier.SUCCESS,
          NotifierMessage.OPERATION_OK
        )
        return response
      }

    } catch (error) {
      // this._error.handleNetwork ( error )
      return undefined
    }
  }

  async update(token: string, serviceId: number, slotId: number, date: string, time: string, flag: number)
  {
    if (!this._utils.checker().isValidText(token)) {
      this._notifier.show(
        Notifier.WARNING,
        NotifierMessage.INVALID_PASSWORD
      )
      return undefined
    }

    if (!this._utils.checker().isValidId(serviceId)) {
      this._notifier.show(
        Notifier.WARNING,
        NotifierMessage.INVALID_SERVICE_ID
      )
      return undefined
    }

    if (!this._utils.checker().isValidId(slotId)) {
      this._notifier.show(
        Notifier.WARNING,
        NotifierMessage.INVALID_SLOT_ID
      )
      return undefined
    }

    if (!this._utils.checker().isValidText(date)) {
      this._notifier.show(
        Notifier.WARNING,
        NotifierMessage.INVALID_SLOT_DATE
      )
      return undefined
    }

    if (!this._utils.checker().isValidText(time)) {
      this._notifier.show(
        Notifier.WARNING,
        NotifierMessage.INVALID_SLOT_TIME
      )
      return undefined
    }

    try {
      const response = await this._request.slot().update(token, serviceId, slotId, date, time, flag).toPromise()

      if (this._error.hasError(response)) {
        // MANAGE ERROR
        return this._error.handleCQWebapp(response)
      }
      else {
        this._notifier.show(
          Notifier.SUCCESS,
          NotifierMessage.OPERATION_OK
        )
        return response
      }

    } catch (error) {
      // this._error.handleNetwork ( error )
      return undefined
    }
  }

  async delete(token: string, serviceId: number, date: string, time: string) {

    if (!this._utils.checker().isValidText(token)) {
      this._notifier.show(
        Notifier.WARNING,
        NotifierMessage.INVALID_PASSWORD
      )
      return undefined
    }

    if (!this._utils.checker().isValidId(serviceId)) {
      this._notifier.show(
        Notifier.WARNING,
        NotifierMessage.INVALID_SERVICE_ID
      )
      return undefined
    }

    if (!this._utils.checker().isValidText(date)) {
      this._notifier.show(
        Notifier.WARNING,
        NotifierMessage.INVALID_SLOT_DATE
      )
      return undefined
    }

    if (!this._utils.checker().isValidText(time)) {
      this._notifier.show(
        Notifier.WARNING,
        NotifierMessage.INVALID_SLOT_TIME
      )
      return undefined
    }

    try {
      const response = await this._request.slot().delete(token, serviceId, date, time).toPromise()

      if (this._error.hasError(response)) {
        // MANAGE ERROR
        return this._error.handleCQWebapp(response)
      }
      else {
        this._notifier.show(
          Notifier.SUCCESS,
          NotifierMessage.OPERATION_OK
        )
        return response
      }

    } catch (error) {
      // this._error.handleNetwork ( error )
      return undefined
    }
  }

  async deleteAll(token: string, serviceId: number, date: string)
  {
    if (!this._utils.checker().isValidText(token)) {
      this._notifier.show(
        Notifier.WARNING,
        NotifierMessage.INVALID_PASSWORD
      )
      return undefined
    }

    if (!this._utils.checker().isValidId(serviceId)) {
      this._notifier.show(
        Notifier.WARNING,
        NotifierMessage.INVALID_SERVICE_ID
      )
      return undefined
    }

    if (!this._utils.checker().isValidText(date)) {
      this._notifier.show(
        Notifier.WARNING,
        NotifierMessage.INVALID_SLOT_DATE
      )
      return undefined
    }

    try {
      const response = await this._request.slot().deleteAll(token, serviceId, date).toPromise()

      if (this._error.hasError(response)) {
        // MANAGE ERROR
        return this._error.handleCQWebapp(response)
      }
      else {
        this._notifier.show(
          Notifier.SUCCESS,
          NotifierMessage.OPERATION_OK
        )
        return response
      }

    } catch (error) {
      // this._error.handleNetwork ( error )
      return undefined
    }
  }


  async createPrenotation(token: string, organizationId: number, serviceId: number, data: Slot, map: any)
  {
    if (!this._utils.checker().isValidText(token)) {
      this._notifier.show(
        Notifier.WARNING,
        NotifierMessage.INVALID_PASSWORD
      )
      return undefined
    }

    if (!this._utils.checker().isValidId(serviceId)) {
      this._notifier.show(
        Notifier.WARNING,
        NotifierMessage.INVALID_SERVICE_ID
      )
      return undefined
    }

    if (!this._utils.checker().isValidText(data.identifier) && organizationId != 200)
    {
      this._notifier.show
      (
        Notifier.WARNING,
        NotifierMessage.SLOT_INVALID_IDENTIFIER
      )
      return undefined
    }

    if( organizationId == 200 )
    {
      if (!this._utils.checker().isValidText(data.name))
      {
        this._notifier.show
        (
          Notifier.WARNING,
          NotifierMessage.SLOT_INVALID_NAME
        )
        return undefined
      }
      if (!this._utils.checker().isValidText(data.surname))
      {
        this._notifier.show
        (
          Notifier.WARNING,
          NotifierMessage.SLOT_INVALID_SURNAME
        )
        return undefined
      }
      if (!this._utils.checker().isValidPhoneNumber(data.phone))
      {
        this._notifier.show
        (
          Notifier.WARNING,
          NotifierMessage.SLOT_INVALID_PHONE_NUMBER
        )
        return undefined
      }
    }

    try
    {
      let response = undefined
      if ( organizationId == 200) response = await this._request.slot().createPrenotationAQP(token, serviceId, JSON.stringify(data), JSON.stringify(map)).toPromise()
      else                        response = await this._request.slot().createPrenotation   (token, serviceId, JSON.stringify(data)).toPromise()

      if (this._error.hasError(response)) {
        // MANAGE ERROR
        return this._error.handleCQWebapp(response)
      }
      else {
        this._notifier.show(
          Notifier.SUCCESS,
          NotifierMessage.OPERATION_OK
        )
        return response
      }

    } catch (error) {
      // this._error.handleNetwork ( error )
      return undefined
    }
  }

  async updatePrenotation(token: string, organizationId: number, serviceId: number, data: Slot, map: any)
  {
    if (!this._utils.checker().isValidText(token)) {
      this._notifier.show(
        Notifier.WARNING,
        NotifierMessage.INVALID_PASSWORD
      )
      return undefined
    }

    if (!this._utils.checker().isValidId(serviceId))
    {
      this._notifier.show(
        Notifier.WARNING,
        NotifierMessage.INVALID_SERVICE_ID
      )
      return undefined
    }

    if (!this._utils.checker().isValidText(data.identifier))
    {
      this._notifier.show
      (
        Notifier.WARNING,
        NotifierMessage.SLOT_INVALID_IDENTIFIER
      )
      return undefined
    }

    if( organizationId == 200 )
    {
      if (!this._utils.checker().isValidText(data.phone))
      {
        this._notifier.show
        (
          Notifier.WARNING,
          NotifierMessage.SLOT_INVALID_PHONE_NUMBER
        )
        return undefined
      }
    }

    try {

      let response = undefined
      if( organizationId != 200) response = await this._request.slot().updatePrenotation   (token, serviceId, JSON.stringify(data)).toPromise()
      else                       response = await this._request.slot().updatePrenotationAQP(token, serviceId, JSON.stringify(data), JSON.stringify(map)).toPromise()

      if (this._error.hasError(response)) {
        // MANAGE ERROR
        return this._error.handleCQWebapp(response)
      }
      else {
        this._notifier.show(
          Notifier.SUCCESS,
          NotifierMessage.OPERATION_OK
        )
        return response
      }

    } catch (error) {
      // this._error.handleNetwork ( error )
      return undefined
    }
  }

  async deletePrenotation(token: string, organizationId: number, serviceId: number, slotId: number, map: any)
  {
    if (!this._utils.checker().isValidText(token)) {
      this._notifier.show(
        Notifier.WARNING,
        NotifierMessage.INVALID_PASSWORD
      )
      return undefined
    }

    if (!this._utils.checker().isValidId(serviceId)) {
      this._notifier.show(
        Notifier.WARNING,
        NotifierMessage.INVALID_SERVICE_ID
      )
      return undefined
    }

    if (!this._utils.checker().isValidId(slotId)) {
      this._notifier.show(
        Notifier.WARNING,
        NotifierMessage.INVALID_SLOT_ID
      )
      return undefined
    }

    try {

      let response = undefined
      if( organizationId == 200) response = await this._request.slot().deletePrenotationAQP(token, serviceId, slotId,  JSON.stringify(map) ).toPromise()
      else                       response = await this._request.slot().deletePrenotation(token, serviceId, slotId).toPromise()


      if (this._error.hasError(response)) {
        // MANAGE ERROR
        return this._error.handleCQWebapp(response)
      }
      else {
        this._notifier.show(
          Notifier.SUCCESS,
          NotifierMessage.OPERATION_OK
        )
        return response
      }

    } catch (error) {
      // this._error.handleNetwork ( error )
      return undefined
    }
  }

  async massImport(token: string, serviceCode: string, serviceId: number, dayId: number, operation: string, days: string, siteList: string, dateBegin: string, dateEnd: string, holidays: number)
  {
    if (!this._utils.checker().isValidText(token)) {
      this._notifier.show(
        Notifier.WARNING,
        NotifierMessage.INVALID_PASSWORD
      )
      return undefined
    }

    if (!this._utils.checker().isValidText(dateBegin)) {
      this._notifier.show(
        Notifier.WARNING,
        NotifierMessage.INVALID_SLOT_DATE
      )
      return undefined
    }

    if (!this._utils.checker().isValidText(dateEnd)) {
      this._notifier.show(
        Notifier.WARNING,
        NotifierMessage.INVALID_SLOT_DATE
      )
      return undefined
    }

    try {
      const response = await this._request.slot().massImport(token, serviceCode, serviceId, dayId, operation, days, siteList, dateBegin, dateEnd, holidays).toPromise()

      if (this._error.hasError(response)) {
        // MANAGE ERROR
        return this._error.handleCQWebapp(response)
      }
      else {
        this._notifier.show(
          Notifier.SUCCESS,
          NotifierMessage.OPERATION_OK
        )
        return response
      }

    } catch (error) {
      // this._error.handleNetwork ( error )
      return undefined
    }
  }

}

